<template>
  <div class="shopping-trolley sub-main">
    <div class="trolley-list warp">
      <div class="total-pro" style="color: #333">
        <!-- 全部商品 {{ cartNumber > 0 ? cartNumber : "" }} 件 -->
        购物车（全部 {{ cartNumber > 0 ? cartNumber : 0 }} 件 ）
      </div>
      <div class="trolley-title">
        <p>
          <el-checkbox
            v-model="selectAll"
            @change="getAllProduct"
            :true-label="1"
            :false-label="0"
            :disabled="list.length > 1"
          />全选
        </p>
        <p>
          <b>商品名称</b>
        </p>
        <!-- <p>库存</p> -->
        <p>商品属性</p>
        <p>单价</p>
        <p>数量</p>
        <p>小计</p>
        <p>操作</p>
      </div>
      <div class="trolley-body">
        <div v-if="noGoods == false">
          <div class="main-list" v-for="(it, index) in list" :key="index">
            <div class="main-shop" v-if="it.skus.length">
              <el-checkbox
                v-model="it.selected"
                @change="selectShop(it)"
                :true-label="1"
                :false-label="0"
              />
              <span class="goToStore" @click="toStore(it.shopId)"
                >店铺: {{ it.shopName }}</span
              >
              <div
                class="discount"
                @mouseenter="showDiscount(it)"
                @mouseleave="hiddenDiscount(it)"
                v-if="false"
              >
                优惠券
                <div class="pop-box" v-if="it.playDiscount">
                  <div class="box-content">
                    <p class="title">可领取的优惠券</p>
                    <ul>
                      <li v-for="(d, dIndex) in it.discountList" :key="dIndex">
                        <p>¥{{ d.count }}</p>
                        <p>
                          <span>{{ d.discount }}</span>
                          <span>{{ d.time }}</span>
                        </p>
                        <p>领取</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="pro-list">
              <!-- products -->
              <div v-if="it.skus.length > 0">
                <div
                  v-for="kt in it.skus"
                  class="pro-child-item"
                  :key="kt.skuId"
                >
                  <div class="item item-checkBox">
                    <el-checkbox
                      v-model="kt.selected"
                      @change="selectProduct"
                      :true-label="1"
                      :false-label="0"
                    />
                  </div>
                  <div class="item">
                    <img
                      :src="kt.image"
                      alt
                      @click="goToProductDetail(kt, it.shopId)"
                    />
                  </div>

                  <div class="item">
                    <p>{{ kt.productName }}</p>
                  </div>
                  <div class="item">
                    <div class="pro-des">
                      <div>
                        <p @click="goToProductDetail(kt, it.shopId)"></p>
                        <p style="padding-left: 29px">
                          {{
                            kt.ifOversold == 1
                              ? "允许超卖"
                              : "库存:" + kt.stockNumber
                          }}
                        </p>
                        <p>
                          <!-- <span>{{ kt.sku }}</span>
                              <span>{{ kt.value }}</span>-->
                          <span>{{ kt.values.join("/") }}</span>
                        </p>
                      </div>
                      <!-- <p class="discounts">限时优惠</p> -->
                    </div>
                  </div>
                  <div class="item">
                    <p>¥ {{ kt.price.toFixed(2) }}</p>
                  </div>
                  <div class="item">
                    <el-input-number
                      :disabled="!kt.shelveState"
                      v-model="kt.number"
                      @change="handleChange(kt)"
                      :min="kt.initPurchase || 1"
                      :max="kt.ifOversold == 1 ? 999999 : kt.stockNumber"
                      :step="1"
                      label="描述文字"
                      size="small"
                    ></el-input-number>
                  </div>
                  <div class="item">
                    <p v-if="kt.shelveState">¥ {{ kt.total.toFixed(2) }}</p>
                    <p v-else class="fs20">(已下架)</p>
                  </div>
                  <div class="item">
                    <p @click="confirDelete(kt)" v-throttle>删除</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="noproduct" v-else>
          <img src="../../../../static/image/noorder@2x.png" alt />
          <p class="fs20 font-color-999">您的购物车还没有商品哦～</p>
        </div>

        <div class="trolley-footer">
          <div class="item item-checkBox">
            <el-checkbox
              v-model="selectAll"
              @change="getAllProduct"
              :true-label="1"
              :false-label="0"
              :disabled="list.length > 1"
            />全选
          </div>
          <div class="item">
            <span
              @click="confirDelete(selectedList, true)"
              class="hover"
              v-throttle
              >删除</span
            >
          </div>
          <div class="item">
            <!-- <span>清除失效的商品</span> -->
            已选商品
            <span>{{ selectedList.length }}</span>
            件
          </div>
          <div class="item">
            全部商品
            <span>{{ cartNumber > 0 ? cartNumber : "" }}</span> 件
          </div>
          <div class="item">
            <p>
              合计 (不含运费) :
              <span>¥ {{ totalProice.toFixed(2) }}</span>
            </p>
            <p>商品优惠: ¥0.00</p>
          </div>
          <div class="item hover" @click="submitOrder" v-throttle>结算</div>
        </div>
      </div>
    </div>
    <delete-goods
      :delete-opt="deleteOpt"
      @close="closePop"
      v-if="deleteOpt.visiable"
      @confirm="deleteGood"
    />
  </div>
</template>

<script>
import { listSearchMixin } from "@/config/mixin";
import api from "@/api_b2c";
import CereHeader from "@/components/canvasShow/cereshop/pc_b2c/header";
import DeleteGoods from "./deleteGoods.vue";
import { mapGetters, mapMutations } from "vuex";
import Cookie from "js-cookie";
export default {
  components: { CereHeader, DeleteGoods },
  mixins: [listSearchMixin],
  data() {
    return {
      deleteOpt: {
        visiable: false,
      },
      selectAll: 0,
      playDiscount: false,
      list: [],
      // 已选择的商品
      selectedList: [],
      // 商品总价
      totalProice: 0,
      noGoods: false,
    };
  },
  created() {
    if (!Cookie.get("token")) {
      this.$message.warning("请先登录");
      this.$store.commit("resetVuex");
      this.$router.push({ path: "/login" });
    } else {
      this.getTrolleyList();
    }
    this.initList();
  },
  computed: {
    ...mapGetters(["cartNumber"]),
  },
  watch: {
    list: {
      handler: (val, oldVal) => {
        // console.log(val, oldVal);
        // val.map(item=>{
        //   // if(JSON.stringify(item.skus) !== JSON.stringify(item))
        // })
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations({
      setShoppingCart: "SET_SHOPPINGCART",
      setCartNumber: "SET_CARTNUMBER",
    }),
    // 初始化采购单数据
    initList() {
      let cartNumber = 0;
      this.list.forEach((j) => {
        cartNumber = cartNumber + j.skus.length;
        j.skus.forEach((k) => {
          this.selectProduct(true);
        });
      });
      console.log(this.list);
      this.setCartNumber(cartNumber);
    },
    // 采购单列表
    async getTrolleyList() {
      const rLoading = this.openLoading();
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET",
      };
      vm.sendReq(params, (res) => {
        const d = res.data;
        if (res.data.length) {
          this.noGoods = false;
        } else {
          this.noGoods = true;
        }
        if (d.length) {
          this.list = d;
          this.setShoppingCart(d);
          this.initList();
        }
        rLoading.close();
      });
    },
    checkVal(big, small) {
      let ids = big.filter((i) => i.selected).map((i) => i.skuId);
      let flag = 1;
      small.map((i) => {
        if (!ids.includes(i.skuId)) {
          flag = 0;
        }
      });
      return flag;
    },
    selectShopAllProduct(val, skus, shopId) {
      // let val = skus.filter(item=>item.selected).length == skus.length ? 0 : 1;
      let skusIds = skus.map((item) => item.skuId);
      this.list.forEach((j) => {
        if (j.shopId === shopId) {
          j.skus.forEach((k) => {
            if (skusIds.includes(k.skuId)) {
              this.$set(k, "selected", val);
            }
          });
        }
      });
      this.selectProduct();
      // skus.forEach(k => {
      //   this.$set(k, "selected", val);
      // });
    },
    // 选择商品
    selectProduct(flag) {
      console.log(flag);
      this.getSelectedProduct(flag);
      this.setShop();
      this.setselectAll();
    },
    // 选择商铺
    selectShop(shop) {
      this.setProduct(shop);
      this.getSelectedProduct();
      this.setselectAll();
    },
    // 全选
    getAllProduct() {
      this.list.forEach((j) => {
        this.$set(j, "selected", this.selectAll);
        j.skus.forEach((k) => {
          this.$set(k, "selected", this.selectAll);
        });
      });
      this.getSelectedProduct();
    },
    // 处理店铺下的商品选择状态
    setProduct(shop) {
      this.list.forEach((j) => {
        if (j.shopId === shop.shopId) {
          j.skus.forEach((k) => {
            this.$set(k, "selected", j.selected);
          });
        }
      });
    },
    // 店铺下的商品全选时, 更新店铺的选中状态
    setShop() {
      this.list.forEach((j) => {
        const flag = j.skus.findIndex((item) => !item.selected);
        this.$set(j, "selected", flag < 0 ? 1 : 0);
      });
    },
    // 店铺全选时, 更新全选状态
    setselectAll() {
      const temp = this.list.findIndex((item) => !item.selected);
      this.selectAll = temp < 0;
    },
    // 选择的商品集合
    getSelectedProduct() {
      let params;
      let shopCarts = [];
      this.list.forEach((j, i) => {
        let skus = [];
        j.skus.forEach((k, n) => {
          const index = this.selectedList.findIndex(
            (item) => item.skuId === k.skuId
          );
          this.$set(k, "total", k.price * k.number);
          if (k.selected && index < 0) {
            this.selectedList.push(k);
          }
          if (!k.selected && index > -1) {
            this.selectedList.splice(index, 1);
          }
          skus[n] = {
            skuId: k.skuId,
            selected: k.selected,
          };
        });
        shopCarts[i] = {
          shopId: j.shopId,
          skus,
        };
      });
      this.getTotalPrice();
      // 将选择的商品上传服务
      params = {
        url: api.selectGood,
        data: {
          shopCarts,
        },
        method: "PUT",
      };
      // 是否是手动选择选商品
      this.sendReq(params, (res) => {
        // console.log(res, '选择')
      });
    },
    // 计算商品总价
    getTotalPrice() {
      let sum = 0;
      this.selectedList.forEach((item) => {
        sum += item.total;
      });
      this.totalProice = sum;
    },
    confirProductAllDelete(skus) {
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "确定删除该商品吗?",
        cancelText: "取消",
        okText: "确定",
        onOk() {
          skus.map((item) => {
            _this.deleteGood({ info: item });
          });
        },
        onCancel() {},
      });
    },
    // 确认是否删除商品
    confirDelete(info, flag) {
      if (flag && !info.length)
        return this.$message.warning("请选中需要删除的商品");
      this.deleteOpt = {
        visiable: true,
        info,
        all: flag,
      };
    },
    // 删除单个商品
    deleteGood(delData) {
      // const id = info.skuId
      const goodList = delData.all ? delData.info : [delData.info];
      let ids = [];
      let params;
      goodList.forEach((it) => {
        let id = it.skuId;
        ids.push(id);
        this.list.map((j) => {
          j.skus.map((k) => {
            if (k.skuId === id) {
              j.skus.splice(
                j.skus.findIndex((item) => item.skuId === id),
                1
              );
            }
          });
        });
      });
      let number = 0;
      this.list.map((j) => {
        j.skus.map((k) => {
          number = number + 1;
        });
      });
      this.setCartNumber(number);
      params = {
        url: api.deleteGoods,
        method: "DELETE",
        data: {
          ids: ids,
        },
      };
      this.selectedList = [];
      this.getSelectedProduct();
      this.closePop();

      this.sendReq(params, (res) => {
        // this.eventId = setTimeout(()=>{
        //   if(this.eventId){
        this.$message.success("删除成功");
        this.getTrolleyList();
        //     this.eventId = null
        //   }
        // },500)
      });

      console.log(this.list);
      let flag = null;
      this.list.map((item) => {
        flag = item.skus.length;
      });
      if (flag) {
        this.noGoods = false;
      } else {
        this.noGoods = true;
      }
    },
    // 修改采购单商品数量
    handleChange(kt) {
      const params = {
        url: api.updateGoodNum,
        method: "PUT",
        data: {
          skuId: kt.skuId,
          number: kt.number,
        },
      };
      this.sendReq(params, (res) => {
        // console.log(res, 1231)
      });
      this.$set(kt, "total", (kt.productPrice || kt.price) * kt.number);
      //同步
      this.list.map((item, num) => {
        item.skus.map((sku, index) => {
          if (sku.skuId == kt.skuId) {
            this.$set(sku, "total", kt.total);
            this.$set(sku, "number", kt.number);
          }
        });
      });
      this.getSelectedProduct();
    },
    // 结算
    submitOrder() {
      let params = {
        url: api.enterprisePass,
        method: "POST",
        data: {},
      };
      // this.sendReq(params, (res) => {
        // if (res.code === "200") {
          let shops = [];
          let down = false;

          this.list.forEach((j, i) => {
            let skus = [];
            j.skus.forEach((k, n) => {
              if (!k.shelveState && k.selected) {
                down = true;
                return this.$message.warning("选中的商品中有下架商品");
              }
              if (k.selected) {
                skus.push({
                  skuId: k.skuId,
                  number: k.number,
                });
              }
            });
            if (skus.length) {
              shops.push({
                shopId: j.shopId,
                skus,
              });
            }
          });
          if (down) {
            return;
          }
          let skusObj = {};
          this.list.map((shop) => {
            shop.skus.map((sku) => {
                if (
                  this.selectedList.map((sku) => sku.skuId).includes(sku.skuId)
                ) {
                  skusObj[shop.shopId] = sku.skuId;
                }
              });
          });
          if (Object.keys(skusObj).length > 1) {
            this.$message.warning(
              "当前不支持跨店下单,您单次内下单只能选择同一家店铺内的商品"
            );
            return;
          }
          if (this.selectedList.length) {
            return this.$router.push({
              name: "b2cPlaceOrder",
              query: {
                type: 2,
                shops: JSON.stringify(shops),
                ifWork: 0,
                activityType: 0,
              },
            });
          }
          return this.$message.warning("请至少选中一件商品");
          //   } else {
          //     this.$message.warning(`${res.message},将为您跳转到认证页面...`);
          //     setTimeout(() => {
          //       this.$router.push({ path: "/companyCertificate" });
          //     }, 2000);
          //   }
          // });
    },
    showDiscount(kt) {
      this.$set(kt, "playDiscount", true);
    },
    hiddenDiscount(kt) {
      this.$set(kt, "playDiscount", false);
    },
    closePop() {
      this.deleteOpt = {
        visiable: false,
      };
    },
    // 跳转到商品详情
    goToProductDetail(item, id) {
      let data = {
        shopId: id,
        productId: item.productId,
        skuId: item.skuId,
      };
      this.$router.push({
        path: "/shop_mall/productDetail",
        query: {
          proData: JSON.stringify(data),
        },
      });
    },
    // 跳转到店铺
    toStore(id) {
      console.log(id, "id");
      this.$router.push({
        path: "/shop_mall/store",
        query: { shopId: id },
      });
    },
  },
};
</script>
<style lang="less">
.main {
  background: #f5f5f5;
}
</style>
<style scoped lang='scss'>
.shopping-trolley {
  width: 80%;
  margin: 20px auto;

  .hover:hover {
    cursor: pointer;
  }
  .trolley-list {
    background: #fff;
    padding: 27px;
    .total-pro {
      font-size: 20px;
      font-weight: bold;
      color: #ff7800;
      margin-bottom: 20px;
    }

    .trolley-title {
      display: flex;
      background-color: #f1f2f7;
      height: 54px;
      line-height: 54px;
      padding: 0 0px;
      p {
        margin: 0;
        color: #333;
        font-size: 16px;
        flex: 1;
        text-align: center;
        &:nth-child(2) {
          flex: 2.5;
          text-align: left;
          b {
            font-weight: normal;
            padding-left: 133px;
          }
        }
        &:nth-child(3) {
          flex: 1;
          text-align: left;
        }
        &:nth-child(1) {
          flex: none;
          margin: 0 22px;
        }
      }
      >>> .el-checkbox {
        margin-right: 5px;
      }
    }

    .trolley-body {
      .main-list {
        .main-shop {
          color: #333;
          font-size: 16px;
          margin: 19px 0 0px;
          padding-left: 20px;
          background: #f1f2f7;
          height: 46px;
          display: flex;
          align-items: center;
          border: 1px solid #e5e5e5;
          border-bottom: none;
          .goToStore {
            cursor: pointer;
            margin-left: 5px;
          }
          .discount {
            color: #ff7800;
            font-size: 14px;
            padding: 8px 9px;
            display: inline-block;
            border: 1px #ff7800 dashed;
            margin-left: 20px;
            position: relative;
            &:hover {
              cursor: pointer;
            }
            .pop-box {
              position: absolute;
              left: 0;
              top: 25px;
              z-index: 2;
              padding-top: 30px;
              .box-content {
                background: #fff;
                padding: 20px;
                border-radius: 4px;
                border: 0.5px #ff7800 solid;
                min-height: 200px;
                min-width: 500px;
                position: relative;
                &::before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-bottom: 12px solid #ff7800;
                  border-left: 8px solid transparent;
                  border-right: 8px solid transparent;
                  top: -13px;
                  left: 25px;
                }
                &::after {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-bottom: 11px solid #fff;
                  border-left: 7px solid transparent;
                  border-right: 7px solid transparent;
                  top: -10px;
                  left: 25.5px;
                }
                .title {
                  font-size: 14px;
                  color: #333;
                }
                ul {
                  li {
                    height: 40px;
                    line-height: 40px;
                    margin-top: 20px;
                    // overflow: hidden;
                    p {
                      float: left;
                      &:nth-child(1) {
                        width: 80px;
                        height: 40px;
                        text-align: center;
                        border: 1px solid #fd5b5b;
                        border-radius: 4px;
                        color: #fd5b5b;
                        font-size: 16px;
                        font-weight: bold;
                        box-sizing: border-box;
                      }
                      &:nth-child(2) {
                        span {
                          display: block;
                          line-height: 20px;
                          color: #666;
                          font-size: 14px;
                        }
                      }
                      &:nth-child(3) {
                        width: 80px;
                        height: 40px;
                        text-align: center;
                        color: #fff;
                        font-size: 16px;
                        font-weight: bold;
                        background: #fd5b5b;
                        border-radius: 4px;
                      }
                      &:nth-child(n + 2) {
                        margin-left: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .pro-list {
          border: 1px solid #e5e5e5;
          & > div {
            border-top: 1px solid #e5e5e5;
          }
          & > div:first-child {
            border-top: none;
          }
          .pro-item,
          .pro-child-item {
            display: flex;
            padding: 36px 0;
            // &:nth-child(n + 2) {
            // border-top: 1px solid #e5e5e5;
            // }
            &:nth-child(2) {
              border-top: none;
            }
            .item {
              flex: 1;
              display: flex;
              align-items: center;
              p {
                text-align: center;
              }
              &:nth-child(1) {
                display: flex;
                align-items: center;
                justify-content: center;
              }
              &:nth-child(2) {
                p {
                  text-align: left;
                  cursor: pointer;
                }

                img,
                .pro-des {
                  float: left;
                }
                img {
                  width: 100px;
                  height: 100px;
                  box-sizing: border-box;
                  cursor: pointer;
                }
              }
              &:nth-child(3) {
                .pro-des {
                  width: calc(100% - 100px);
                  box-sizing: border-box;
                  padding-left: 30px;
                  // height: 100%;
                  position: relative;
                  div {
                    p {
                      float: left;
                      overflow: hidden;
                      &:nth-child(1) {
                        width: 41%;
                        color: #333;
                        font-size: 16px;
                        padding-right: 30px;
                        box-sizing: border-box;
                      }
                      &:nth-child(2) {
                        width: 33%;
                        span {
                          display: block;
                          font-size: 16px;
                          color: #999;
                        }
                      }
                    }
                  }
                  p.discounts {
                    position: absolute;
                    bottom: 0;
                    left: 20px;
                    clear: both;
                    background: #fff2ed;
                    font-size: 14px;
                    color: #ff7800;
                    border-radius: 2px;
                    padding: 4px 7px;
                    display: inline-block;
                  }
                }
              }
              &:nth-child(5) {
                color: #ff7800;
                font-weight: bold;
                padding-left: 10px;
              }
              &:last-child {
                &:hover {
                  cursor: pointer;
                }
              }
            }
            .item.item-checkBox {
              // width: 82px !important;
              flex: 0;
              margin: 0 36px 0 47px;
            }
          }
          .pro-child-item {
            padding-left: 10px;
            padding-right: 11px;
            .item {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              &:nth-child(4) {
                flex: 2;

                .pro-des {
                  div {
                    p {
                      &:nth-child(2) {
                        width: 80%;
                        span {
                          display: block;
                          font-size: 16px;
                          color: #999;
                        }
                      }
                    }
                  }
                }
              }
              &:nth-child(5) {
                // flex: 2;
                padding-left: 42px;
              }
            }
          }
        }
      }
      .noproduct {
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
    }

    .trolley-footer {
      margin: 60px 0 100px;
      background-color: #f1f2f7;
      height: 80px;
      display: flex;
      font-size: 16px;
      align-items: center;
      color: #333;
      .item {
        flex: 1;
        &:nth-child(1) {
          padding-left: 22px;
        }
        &:nth-child(4),
        &:nth-child(3) {
          span {
            color: #ff7800;
            font-size: 20px;
          }
        }
        &:nth-child(5) {
          flex: 3;
          padding-right: 15px;
          p {
            text-align: right;
            line-height: normal;
            span {
              color: #ff7800;
              font-size: 20px;
            }
          }
        }
        &:nth-child(n-2) {
          line-height: 40px;
        }
        &:last-child {
          width: 100px;
          text-align: center;
          font-size: 20px;
          color: #fff;
          background-color: #ff7800;
          line-height: 80px;
        }
        >>> .el-checkbox {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/b2c/shopping-trolley/index.vue